<div class="modal-header bg-light">
    <h4 class="modal-title strong">{{'tenders.Moredetails'|cxTranslate}}</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
          </button>
</div>
<hr class="my-0">
<div class="modal-body bg-light">
    <div class="row">
        <div class="col-12 col-md-6">
            <div class="mb-2">
                <div class="small text-secondary small">{{'tenders.DemurrageRate'| cxTranslate}}</div>
                <div class="small wrap">{{tenderDetailsData ?.demurrageRate?tenderDetailsData ?.demurrageRate:'--'}}</div>
            </div>
            <div class="mb-2">
                <div class="small text-secondary small">{{'tenders.DespatchRate'| cxTranslate}}</div>
                <div class="small mb-3">{{tenderDetailsData ?.despatchRate?tenderDetailsData ?.despatchRate:'--'}}</div>
            </div>
        </div>
        <div class="col-12 col-md-6">
            <div class="d-flex flex-column">
                <div class="strong mb-2">{{'tenders.Attachment'|cxTranslate}}</div>
                <div *ngFor="let docs of tenderDetailsData?.documents;let i=index" class="d-flex flex-row"> <img src="/images/attachment.svg" alt="icon" width="9" height="17" class="mt-1"> 
				<a class="ml-1 mb-0 strong strong shadow-none minimum-height" href="{{docs.downloadURL}}" target="_blank"><span class="small ml-1 pe-auto mb-2 strong text-primary text-capitalize">{{docs?.documentName?docs?.documentName:'--'}}</span></a>				
				</div>
            </div>
        </div>
    </div>
</div>
